// @spec AI-STR-015
// TanStack Router route for compliance alerts page

import { createFileRoute } from '@tanstack/react-router';

import { AlertsPage } from '@/features/ai/alerts';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/compliance/alerts')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.complianceAlerts'),
  }),
  component: ComplianceAlertsPage,
});

function ComplianceAlertsPage() {
  return <AlertsPage />;
}
